import { render, staticRenderFns } from "./CaptchaSheet.vue?vue&type=template&id=5d8bc5f0&"
import script from "./CaptchaSheet.vue?vue&type=script&lang=js&"
export * from "./CaptchaSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports